<template>
<div class="process-module">
  <div class="process-time">
    <slot name="process-time"></slot>
  </div>
  <div :class="dotClass"></div>
  <div class="process-flag">
    <div class="process-pic">
      <slot name="process-pic"></slot>
    </div>
    <div class="flag-content">
      <div class="flag-content-title">
        <slot name="process-content-title"></slot>
      </div>
      <div class="flag-content-desc" :class="[{'flag-content-desc-en': lang === 'en'},{'flag-content-desc-zh': lang === 'zh'}]">
        <slot name="process-content-desc"></slot>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import {
  mapGetters
} from 'vuex'
export default {
  props: {
    schedule: String
  },
  computed: {
    ...mapGetters({
      lang: 'getLang'
    }),
    dotClass: function () {
      return [`${this.schedule}-dot`]
    }
  }
}
</script>

<style lang="scss" scoped>
.process-module {
  position: absolute;
  width: 34.4rem;

  @media screen and (max-width: 768px) {
    width: 345px;
  }

  .process-time {
    float: left;
    @include nkn-font-set(.9rem, currentColor);
  }

  .small-dot {
    @include dot-style($width: .7rem, $height: .7rem, $bgcolor:currentColor);
    position: absolute;
    right: 24.4rem;
    top: .35rem;

    @media screen and (max-width: 768px) {
      left: 6.95rem;
    }
  }

  .big-dot {
    @include dot-style($width: 1.1rem, $height: 1.1rem, $bgcolor:currentColor, $boxshadow: 0 0 .3rem .1rem currentColor);
    position: absolute;
    right: 24.2rem;
    top: .35rem;

    @media screen and (max-width: 768px) {
      left: 6.8rem;
    }
  }

  .process-flag {
    float: right;

    @media screen and (max-width: 768px) {}

    .process-pic {
      display: inline-block;
      vertical-align: middle;
    }

    .flag-content {
      display: inline-block;
      width: 17.9rem;
      margin-left: .75rem;
      color: currentColor;
      vertical-align: middle;

      @media screen and (max-width: 768px) {
        width: 150px;
      }

      &-title {
        @include nkn-font-set(1.5rem, currentColor);
        line-height: 2rem;

        @media screen and (max-width: 768px) {
          @include nkn-font-set(1.2rem, currentColor);
        }
      }

      &-desc {
        @include nkn-font-set(.7rem, currentColor, 400);
        line-height: 1rem;

        // @media screen and (max-width: 768px) {
        //   word-break: keep-all;
        // }

        &-en {
          word-break: keep-all;
        }

        &-zh {
          word-break: break-all;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/about/plugins/ProcessModule.vue